// extracted by mini-css-extract-plugin
export default {"white":"#fff","notificationRed":"#ff4c68","primaryIcon":"#309df0","MenuItem":"bhe_a bik_vt bik_ea bik_a","MenuItem__Btn":"bhe_b bik_z","MenuItem__subtitle":"bhe_c"};